export const AppColors = {
    almostBlack: "#0d151a",
    background: "#132026",
  }